





export const notesData = [
    { 
        semester: "1", 
        subject: "Mathematics", 
        title: "Calculus Fundamentals"
    },
    { 
        semester: "1", 
        subject: "Physics", 
        title: "Mechanics and Waves"
    },
    { 
        semester: "1", 
        subject: "Chemistry", 
        title: "Organic Chemistry Basics"
    },
    { 
        semester: "2", 
        subject: "Mathematics", 
        title: "Linear Algebra"
    },
    { 
        semester: "2", 
        subject: "Biology", 
        title: "Cell Biology"
    },
    { 
        semester: "2", 
        subject: "Computer Science", 
        title: "Data Structures"
    },
    { 
        semester: "3", 
        subject: "ENVIRONMENTAL ENGINEERING", 
        title: " CS-301 Notse "
    },
    { 
        semester: "3", 
        subject: "Discrete Structures", 
        title: " CS-302 Notse"
    },
    { 
        semester: "3", 
        subject: "DATA STRUCTURE", 
        title:  " CS-303 Notse"
    },
     { 
        semester: "3", 
        subject: "Digital systems", 
        title:  " CS-304 Notse"
    },
      { 
        semester: "3", 
        subject: "OBJECT ORIENTED PROGRAMMING", 
        title:  " CS-305 Notse"
    },

  { 
        semester: "4", 
        subject: "Mathematics-III", 
        title: " CS-401 Notse"
    },
    { 
        semester: "4", 
        subject: "Analysis & Design of Algorithms", 
        title: " CS-402 Notse"
    },
    { 
        semester: "4", 
        subject: "Software Engineering", 
        title: " CS-403 Notse"
    },
    { 
        semester: "4", 
        subject: "Computer Organization & Architecture", 
        title: " CS-404 Notse"
    },
    { 
        semester: "4", 
        subject: "Operating Systems", 
        title: " CS-405 Notse"
    },
    { 
        semester: "5", 
        subject: "Theory of Computation", 
        title: "501 Exam paper -2024"
    },
     { 
        semester: "5", 
        subject: "Internet and Web Technology", 
        title: "502- UNIT-1"
    },
     { 
        semester: "5", 
        subject: "Internet and Web Technology", 
        title: "504- UNIT-2"
    },
    
   
     { 
        semester: "5", 
        subject: "Internet and Web Technology", 
        title: "502- UNIT-4"
    },
    { 
        semester: "5", 
        subject: "Internet and Web Technology", 
        title: "502- UNIT-5"
    },
    { 
        semester: "5", 
        subject: "Pattern Recognition", 
        title: "503- UNIT-1,2 Notse" 
       
    }
];

